import React,{Component} from 'react';
import { Link,browserHistory } from 'react-router';
import { ccAvenue,razorpayForm } from "../../functions/custom_functions.js";
import $ from 'jquery';
import {connect} from 'react-redux';
import * as actions from '../../../actions';

// /shipping_payment/:Type/:Book_Id/:Uid

const baseAssets='https://aquadeals.in/admin/assets/';

class Shipping_Payment extends Component{
	constructor(props){
		super(props);
		this.state={
			pre_payment_id:'',
			order_id:'',
			paid_amt:'',
			book_type:'',
			
			shipaddress:[],
			username:'',
			address:'',
			city:'',
			state:'',
			pincode:'',
			mobile:'',
			email:'',

			payment_details:'',
			pros:[],
			shipment_details:'',
			deal_type:'',
			booking_data:[],
			tot_data:[],
			billing_status:false,
			page_error_status:false,
			pageId:'.shipping_payment_page',			
		}
		this.getShippingDetails=this.getShippingDetails.bind(this);
		this.enableBillingDetails=this.enableBillingDetails.bind(this);
	}
	componentDidMount()
	{
		if(screen.width >= 800)
		{
			window.location.href='/web/shipping_payment/'+this.props.params.Type+'/'+this.props.params.Book_Id+'/'+this.props.params.Uid;
			// window.location.href='http://203.193.173.125/web/shipping_payment/'+this.props.params.Type+'/'+this.props.params.Book_Id+'/'+this.props.params.Uid;
		}
		if(!localStorage.token && !localStorage.user_id)
		{
			localStorage.setItem('shipping','/shipping_payment/'+this.props.params.Type+'/'+this.props.params.Book_Id+'/'+this.props.params.Uid)
			browserHistory.push('/login');
		}
		else
		{
			this.getShippingDetails();
		}
	}
	enableBillingDetails()
	{
		this.setState({
			billing_status: true,
		});
	}	
	getShippingDetails()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		if(localStorage.source)
	    {
    	    var source=localStorage.getItem('source');
      	}
      	else
      	{
        	source='';
      	}
      	if(localStorage.campaign)
    	{
	        var campaign=localStorage.getItem('campaign');
	    }
	    else
	    {
	        campaign='';
	    }
      	if(localStorage.url_id)
      	{
	        var url_id=localStorage.getItem('url_id');
    	}
      	else
      	{
        	url_id='';
      	}
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:uid,token:localStorage.token,bid:this.props.params.Book_Id,type:this.props.params.Type,pid:this.props.params.Uid,source:source,campaign:campaign,url_id:url_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'get_shipment_stat',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						payment_details:data.payment_details,
						pros:data.pros,
						shipment_details:data.shipment_details,
						deal_type:data.deal_type,
						booking_data:data.booking_data,
						tot_data:data,
					});	
				}
				else if(data.status==='error' && data.message==='You are not authorized')
				{
					this.setState({
						page_error_status: true,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	componentWillMount()
	{
		var that=this;
		setTimeout(function(){
			that.enableBillingDetails();
		},3000);
	}
	// payNow(book_id,paid_amt,pay_type,book_type,u_name,u_address,u_phone,u_zip,u_city,u_state,u_email)
	payNow()
	{
		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,bid:this.props.params.Book_Id,type:this.props.params.Type,pid:this.props.params.Uid,source:source,campaign:campaign,url_id:url_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			url: baseUrl+'ship_payment_temp_process',
			dataType:'json',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						pre_payment_id:data.pre_payment_id,
						order_id:data.order_id,
						paid_amt:data.paid_amt,
						book_type:data.book_type,
						
						username:data.shipaddress[0].name,
						address:data.shipaddress[0].address,
						city:data.shipaddress[0].city,
						state:data.shipaddress[0].state,
						pincode:data.shipaddress[0].zip,
						mobile:data.shipaddress[0].phone,
						email:data.shipaddress[0].email,
						gateway_mode:data.gateway_mode,						
						
					});
					var payment_params= {from:'mobile_web',
					uid:localStorage.getItem('user_id'),
					pre_payment_id:this.state.pre_payment_id,
					order_id:this.state.order_id,
					deal_type:this.state.book_type,
					cart_ids:'',
					paid_amt:this.state.paid_amt,					
					username: this.state.username,
					address:this.state.address,
					city:this.state.city,
					state:this.state.state,
					pincode:this.state.pincode,
					mobile:this.state.mobile,
					country:'India',
					email:this.state.email,
					cart_add_id:'shipping_amt',
					pageId:this.state.pageId,
					rzp_key:this.props.rzp_keys.key_id};
					if(this.state.gateway_mode == 2){					
						razorpayForm(payment_params);
						this.setState({
							page_loading:false,
						});											
					}else{											
						ccAvenue(payment_params);
					}
				}
				
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}

		});
	}
	render(){
		document.title="Shipping Payment | AquaDeals";
		if(this.state.pros.length > 0)
		{
			if(this.state.deal_type==='1')
			{
				var products=this.state.pros.map(function(order,index){
					return( <div className="">
						<div className="order_list_items">
							<div className="col-xs-12 col-md-12 order_subitems">
								<div className="col-xs-3 col-md-3" style={{padding:'0px'}}>
									<i className="order_icon"><img src={order.image} alt="" /></i>
								</div>
								<div className="col-xs-9 col-md-9" style={{padding:'0px'}} >
									{order.title ? <p>{order.title}</p> : <p>&nbsp;</p>}
									{order.brand || order.total_amount ? <p><span style={{fontSize:'10px',color:'#999'}}>{order.brand}</span><span style={{float:'right'}}>&#8377; {order.total_amount}</span></p>: <p>&nbsp;</p>}
									<p>Price &#8377; {order.mrp} <span>Quantity {order.quantity} </span> </p>
								</div>
							</div>
						</div>
					</div>)
				});		
			}
			else
			{
				products=this.state.pros.map(function(order,index){
					return(
						<div className="">
							<div className="order_list_items">
								<div className="col-xs-12 col-md-12 order_subitems">
									<div className="col-xs-2 col-md-2" style={{padding:'0px'}}>
										<i className="seed_order_icon"><img src={order.image} alt="" /></i>
									</div>
									<div className="col-xs-10 col-md-10" style={{padding:'0px'}} >
										{order.specie ? <p style={{color:'#333'}}>{order.specie}</p>: <p>&nbsp;</p>}
										{order.total_amount ? <p><span style={{float:'right'}}>&#8377; {order.total_amount}</span></p> : <p>&nbsp;</p>}
										<p style={{color:'#999'}}><span>Plsize</span>&nbsp;<span>{order.plsize}</span>&nbsp;<span>Salinity</span>&nbsp;<span>{order.salinity}</span></p>
										{/*<p><span>{order.brand}</span><span style={{float:'right'}}>&#8377; {order.total_amount}</span></p>*/}
										<p>Price &#8377; {order.mrp} <span>Quantity {order.quantity}</span></p>
									</div>
								</div>
							</div>
						</div>
					);
					})
			}
		}
		
		// if(this.state.shipment_details.length > 0)
		// {
		// 	var shipment_details=<div style={{marginTop:'10px'}}>
		// 						<h5 className="ordr_header">SHIPPING DETAILS</h5>
		// 						{this.state.shipment_details.map(function(item,index){
		// 							return(
		// 								<h5 className="ordr_dtls_4"><span>{item.title}</span><span style={{float:'right'}}>&#8377; {item.value}</span></h5>
		// 								);
		// 							})}
		// 					</div>;
		// }
		// else
		// {
		// 	shipment_details='';
		// }

		var status='';
		if(this.state.tot_data)
		{
			if(this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status==='0' || this.state.tot_data.booking_data[0]==='4' || this.state.tot_data.booking_data[0].status==='7' : '')
			{
				status='Order Placed';
			}
			else if(this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status==='1' : '')
			{
				status='Processing';
			}
			else if(this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status==='3' : '')
			{
				status='Cancelled';
			}
			else if(this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status==='5' : '')
			{
				status='Shipping';
			}
			else if(this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status==='6' : '')
			{
				status='Delivered';
			}
		}
		
		var b_id=this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].booking_id : '';
		var total_discount = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].total_discount : '';
		var book_date = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].created_on : '';
		return(
			<div className="mob_deals shipping_payment_page">
				<div className="page_hdr">
					<div className="container-fluid">
						<h5><Link to={'/'}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Shipping Payment</h5>
						<a href="/" title="Home" className="home_logo1"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/home1.png'} alt="Home" /></a>
				    </div>
				</div>
				<div className="pag_cntnt">&nbsp;</div>
				{this.state.page_error_status ? <div className="ship_error_block"><h4>You are not authorized</h4><a href="/">Explore Deals</a></div> :
				<div className="ship_dtls_cnt_blk">
					<section className="ordr_dtls_1">
						{this.state.booking_data ? <div>
							<p><span>{b_id}</span><span className="right_side">&#8377; {total_discount}</span></p>
							<p><span style={{fontSize:'10px'}}>{book_date}</span><span className="order_details_status">{status}</span></p>
						</div> : ''}
					</section>
					<div className="ship_dtls_pro_blk">
						{this.state.pros.length > 1 ? <p style={{paddingLeft:'10px',marginTop:'5px'}}>You have {this.state.pros.length} items in your order</p> : <p style={{paddingLeft:'10px',marginTop:'5px'}}>You have {this.state.pros.length} item in your order</p> }
						{products}
						{this.state.tot_data.progress_bar !="" ?
							<div className="col-md-12 col-sm-12 col-xs-12">
								<i><img src={'https://aquadeals.in/admin/assets/images/product_imgs/'+this.state.tot_data.progress_bar} alt="" /></i>
							</div>
							: 
							''						
						}
					</div>
					{/*<div>
						{shipment_details}
					</div>*/}
					<div className="" style={{marginTop:'10px'}}>
						<h5 className="ordr_header">ORDER SUMMARY</h5>
							{this.state.billing_status ? <div className="ordr_dtls_3">
								<table className="table cart_table">
									<tr className="cart_tr_total">
										<td>Order Total</td>
										<td>&#8377; {this.state.tot_data.total_amount}</td>
									</tr>
									{this.state.tot_data.aqua_cash1 && parseInt(this.state.tot_data.aqua_cash1,10) > 0 ? <tr className="cart_tr">
										<td>Aquacash Discount</td>
										<td>(-) &#8377; {this.state.tot_data.aqua_cash}</td>
									</tr> : ''}
									
									{this.state.tot_data.coupons_amt1 && parseInt(this.state.tot_data.coupons_amt1,10) > 0 ? 
									<tr className="cart_tr">
										<td>Applicable Coupons</td>
										<td>(-) &#8377; {this.state.tot_data.coupons_amt}</td>
									</tr> : ''}
									{this.state.tot_data.seller_discount1 && parseInt(this.state.tot_data.seller_discount1,10) > 0 ? 
										<tr className="cart_tr">
											<td>Seller Discount</td>
											<td>(-) &#8377; {this.state.tot_data.seller_discount}</td>
										</tr>
										: ''}
									{this.state.tot_data.promo_manf_value1 && parseInt(this.state.tot_data.promo_manf_value1,10) > 0 ?
										<tr className="cart_tr">
											<td>Promo Discount</td>
											<td>(-) &#8377; {this.state.tot_data.promo_manf_value}</td>
										</tr>
									 : ''}
									{this.state.tot_data.promo_hatch_value1 && parseInt(this.state.tot_data.promo_hatch_value1,10) > 0 ?
										<tr className="cart_tr">
											<td>Promo Discount</td>
											<td>(-) &#8377; {this.state.tot_data.promo_hatch_value}</td>
										</tr>
									 : ''}

									<tr className="cart_tr_grandtotal">
										<td>&nbsp;</td>
										<td>Total &nbsp; &nbsp; &#8377; {this.state.tot_data.total_discount}</td>
									</tr>
									{this.state.tot_data.ship_value1 && parseInt(this.state.tot_data.ship_value1,10) > 0 ?
										<tr className="ship_grandtotal">
											<td>You need to pay shipping charges</td>
											<td>(+) &#8377; {this.state.tot_data.ship_value}</td>
										</tr>
									 : ''}

								</table> 
							
							</div> : <div className="price_loading"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  /></div>}
					</div>
					<div className="ship_pay_blk">
						<a className="ship_pay_btn" onClick={()=>{this.payNow()}}>PAY NOW</a>
					</div>
				</div> }
			</div>
		);
	}
}
function mapStateToProps(state){
    return {
 		rzp_keys: state.posts.rzp_keys
    }
}
export default connect(mapStateToProps,actions)(Shipping_Payment);


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Orders/Shipping_Payment.js
 **/